import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material'

/**
 * Error message component that is displayed when something fatal happens and the
 * app cannot render itself. Translations are not available yet on this level so
 * text should be hardcoded.
 */
export const ErrorMessage = (props: { title: string; details?: string }) => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}>
      <Grid item xs={3}>
        <Paper
          sx={theme => ({
            p: 3,
            minWidth: { xs: 320, sm: 560 },
            backgroundColor: 'background.neutral',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '10px',
            boxShadow: 'none',
          })}>
          <Stack gap={1.5} alignItems="flex-start">
            <Typography variant="h6">{props.title}</Typography>
            {props.details && (
              <Typography variant="body2" color="text.secondary">
                {props.details}
              </Typography>
            )}
            <Box mt={1}>
              <Button variant="contained" onClick={() => window.location.reload()}>
                Try again
              </Button>
            </Box>
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  )
}
